import { render, staticRenderFns } from "./AboutMember.vue?vue&type=template&id=0480b4e8&scoped=true"
import script from "./AboutMember.vue?vue&type=script&lang=js"
export * from "./AboutMember.vue?vue&type=script&lang=js"
import style0 from "./AboutMember.vue?vue&type=style&index=0&id=0480b4e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0480b4e8",
  null
  
)

export default component.exports